/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { InventoryGcpDisk } from '../models/InventoryGcpDisk';

/**
* Properties of the original GCP VM instance. Present only when `resourceType` is set to `GCP_VM_INSTANCE`. 
*/
export class GcpVmResource {
  /**
  * List of disks attached to the resource.
  */
  'disks'?: Array<InventoryGcpDisk>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "disks",
      "baseName": "disks",
      "type": "Array<InventoryGcpDisk>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GcpVmResource.attributeTypeMap;
  }

  public constructor() {
  }
}

